import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AgendamentoDespesaEditarRoutingModule } from "./agendamento-despesa-editar-routing.module";
import { AgendamentoDespesaEditarComponent } from "./agendamento-despesa-editar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from "primeng/inputnumber";
import { ProgressSpinnerModule } from "primeng/progressspinner";




@NgModule({
    imports: [
        CommonModule,            
        AgendamentoDespesaEditarRoutingModule,
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        InputMaskModule,
        MessagesModule,
        TableModule,
        InputSwitchModule,
        CheckboxModule,
        CalendarModule,
        InputNumberModule,
        ProgressSpinnerModule,
        MessagesModule

    ],
    declarations: [AgendamentoDespesaEditarComponent]
})
export class AgendamentoDespesaEditarModule { }
